import { IApplicationState } from '../../types/redux';

export function selectNotFoundUrl(state: IApplicationState) {
  const { notFoundUrl } = state;

  return notFoundUrl;
}
